import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { IoWarning } from "react-icons/io5";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx("div", {
        style: {
            color: "#ffb700"
        },
        children: /*#__PURE__*/ _jsx(IoWarning, _object_spread({
            size: 22
        }, props))
    });
};
export default Icon;
